module.exports = __webpack_public_path__ + "03_glasses_red.913f338d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer4/03_glasses_red.png
// module id = aOrq
// module chunks = 0